import { Box, Button, List, ListItem, ListItemText, Typography } from "@material-ui/core"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { useDialog } from "../../../../services/app/providers/dialog-provider"
import { ReactNode, useMemo } from "react"
import { OkIcon } from "../../icons/ok-icon"
import { DialogPermissaoLocalizacaoProps } from "./dialog-permissao-localizacao-props"
import { getNavegador, isSmartphone, type Navegador } from "../../../../utils/get-navegador"
import { OpcoesIcon } from "../../icons/opcoes-icon"
export type { DialogPermissaoLocalizacaoProps }

const passosChromeSmartphone: (string | ReactNode)[] = [
    <>
        Clique no ícone de opções{" "}
        <Box component="span" display="inline-flex" style={{ margin: "0 4px", verticalAlign: "middle" }}>
            <OpcoesIcon tipo="BUTTON" style={{ width: 20, height: 20 }} />
        </Box>{" "}
        do lado esquerdo da barra de endereço (URL).
    </>,
    "Toque em \"Permissões\".",
    "Habilite a localização para este site.",
    "Recarregue a página e tente novamente.",
]

const passosPorNavegador: Record<Navegador, (string | ReactNode)[]> = {
    chrome: [
        "Clique no ícone de cadeado na barra de endereço (à esquerda da URL).",
        "Selecione \"Configurações do site\".",
        "Em \"Localização\", escolha \"Permitir\".",
        "Recarregue a página e tente novamente.",
    ],
    edge: [
        "Clique no ícone de cadeado na barra de endereço (à esquerda da URL).",
        "Selecione \"Permissões para este site\" ou \"Configurações do site\".",
        "Em \"Localização\", altere para \"Permitir\".",
        "Recarregue a página e tente novamente.",
    ],
    firefox: [
        "Clique no ícone de escudo ou cadeado na barra de endereço (à esquerda da URL).",
        "Clique em \"Mais informações\" e depois em \"Permissões\".",
        "Localize \"Localização\" e marque como \"Permitir\".",
        "Recarregue a página e tente novamente.",
    ],
    safari: [
        "No menu, vá em Ajustes (ou Preferências) e abra \"Sites\" ou \"Websites\".",
        "No menu lateral, selecione \"Localização\".",
        "Encontre este site na lista e defina como \"Permitir\".",
        "Recarregue a página e tente novamente.",
    ],
    outros: [
        "Abra as configurações ou preferências do seu navegador.",
        "Procure por \"Privacidade\", \"Permissões\" ou \"Configurações do site\".",
        "Habilite a permissão de localização para este site.",
        "Recarregue a página e tente novamente.",
    ],
}

export const DialogPermissaoLocalizacao = ({ aberto }: DialogPermissaoLocalizacaoProps) => {
    const { fecharPermissaoLocalizacao } = useDialog()

    const passos = useMemo(() => {
        const navegador = getNavegador()
        const mobile = isSmartphone()
        const isChromeSmartphone = navegador === "chrome" && mobile
        return isChromeSmartphone ? passosChromeSmartphone : passosPorNavegador[navegador]
    }, [])

    return (
        <DialogSaurus
            aberto={aberto}
            titulo="Permissão de localização"
            tamanho="sm"
            centralizarTitulo
        >
            <Box display="flex" flexDirection="column" gridGap={16} mt={2}>
                <Typography>
                    É necessário permitir o acesso à sua localização para continuar.
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                    Siga os passos abaixo para ativar a permissão no seu navegador:
                </Typography>
                <List dense disablePadding>
                    {passos.map((texto, index) => (
                        <ListItem key={index} disableGutters alignItems="flex-start">
                            <ListItemText
                                primary={
                                    typeof texto === "string" ? (
                                        `${index + 1}. ${texto}`
                                    ) : (
                                        <Typography component="span" variant="body2">
                                            {index + 1}. {texto}
                                        </Typography>
                                    )
                                }
                                primaryTypographyProps={{ variant: "body2" }}
                            />
                        </ListItem>
                    ))}
                </List>
                <Box pt={1}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={fecharPermissaoLocalizacao}
                        startIcon={<OkIcon tipo="BUTTON_PRIMARY" />}
                    >
                        Entendi
                    </Button>
                </Box>
            </Box>
        </DialogSaurus>
    )
}
